import React, { useEffect, useState, useMemo } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useLocation,
  useHistory,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "react-i18next";
import "./i18n";
import Login from "./Pages/Login";
import BossMainPage from "./Pages/BossMainPage";
import LandingPage from "./Pages/LandingPage";
import BossEmployee from "./Pages/BossMainPageComps/BossEmployee";
import BossStatisticEmployeeData from "./Pages/BossMainPageComps/BossStatisticComps/BossStatisticEmployeeData";
import AccountAntMainPage from "./Pages/AccountAntMainPage";
import AccountAntHome from "./Pages/AccountantComps/AccountAntHome";
import AccountantHomeContractorMainPage from "./Pages/AccountantComps/AccountantContractorComps/AccountantHomeContractorMainPage";
import BossPlacesData from "./Pages/BossMainPageComps/BossPlacesComps/BossPlacesData";
import ForgotPassword from "./Pages/ForgotPassword";
import Register from "./Pages/Register";
import BossStatisticPlacesData from "./Pages/BossMainPageComps/BossStatisticComps/BossStatisticPlacesData";
import BossStatisticByDateData from "./Pages/BossMainPageComps/BossStatisticComps/BossStatisticByDateData";
import BossStatisticCreateExpenses from "./Pages/BossMainPageComps/BossStatisticComps/BossStatisticCreateExpenses";
import BossCalcPage from "./Pages/BossMainPageComps/BossCalcPage";

//for local
//export const MyDomain = "http://10.0.0.4/";
//export const MyDomain = "http://172.30.240.1/";
//export const MyDomain = "http://172.20.10.2/";
export const MyDomain =
  "https://neholesek.happymushroom-066fb8ce.westeurope.azurecontainerapps.io/";
//export const MyDomain = "http://172.17.240.1/";
//export const MyDomain = "http://172.26.0.1/";

//for cloud
const App = () => {
  const { i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const lang = JSON.parse(localStorage.getItem("lang")) ?? JSON.stringify("he");
  const location = useLocation();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const history = useHistory();

  useEffect(() => {
    changeLanguage(lang);
    const normalizedPath = window.location.pathname.toLowerCase();
    if (window.location.pathname !== normalizedPath) {
      history.replace(normalizedPath); // Redirect to lowercase URL
    }
  }, [history]);

  useEffect(() => {
    //handleClearSpecificItem();
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // const handleClearSpecificItem = () => {
  //   const keyToRemove = "wishList"; // Replace 'yourKey' with the key of the item you want to remove
  //   localStorage.removeItem(keyToRemove);
  //   console.log(`${keyToRemove} removed from localStorage`);
  // };

  return (
    <div
      style={{
        justifyContent: "center",
        fontFamily: "Droid Arabic Kufi, sans-serif",
      }}
    >
      <Switch>
        <Route exact path="/" component={LandingPage} />
        <Route path="/boss-main-page/:BossId" component={BossMainPage} />
        <Route exact path="/login" component={Login} />
        <Route
          path="/boss-employee-statistics/:BossId"
          component={BossStatisticEmployeeData}
        />
        <Route
          path="/boss-statistic-places-data"
          component={BossStatisticPlacesData}
        />

        <Route
          path="/accountant-main-page/:AccountantId"
          component={AccountAntMainPage}
        />
        <Route
          path="/accountant/contractor-details"
          component={AccountantHomeContractorMainPage}
        />
        <Route path="/forgot-password" component={ForgotPassword} />
        <Route path="/register" component={Register} />
        <Route
          path="/boss-statisticby-date-data"
          component={BossStatisticByDateData}
        />
        <Route
          path="/boss-statistic-create-expenses"
          component={BossStatisticCreateExpenses}
        />
        <Route path="/boss-calc-page" component={BossCalcPage} />
      </Switch>
    </div>
  );
};
export default App;
